import { axiosChartInstance } from "config";
import { useAxiosMutation } from "hooks";

function useDeleteAddendumAttachment() {
  return useAxiosMutation(
    ["deleteAddendumAttachment"],
    (attachmentId: string) =>
      axiosChartInstance.delete(`v1/addendum/attachments/${attachmentId}`)
  );
}

export { useDeleteAddendumAttachment };
